import { PageWrapper } from '../../lib/styles';
import UserSignupForm from '../../components/signup/UserSignupForm';
import { NextPage } from 'next';
import withApollo from '../../lib/withApollo';
import { ThemeProvider } from '@lifechurch/react-ion';

const SignupUser: NextPage = () => {
  return (
    <PageWrapper>
      <ThemeProvider openNetwork={true}>
        <UserSignupForm />
      </ThemeProvider>
    </PageWrapper>
  );
};

SignupUser.getInitialProps = async () => undefined;

export default withApollo(SignupUser);
